import React from 'react';
import { Button } from '@/components/ui/button';
import { setNotificationBanner } from '../redux/slices/appSlice';
import { useDispatch } from 'react-redux';
import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import Icon from '../utils/components/Icon';

function NotificationBanner() {
  const dispatch = useDispatch();

  return (
    <div className="flex w-full flex-wrap items-center justify-center bg-primary p-4 text-primary-foreground">
      <div className="flex flex-1 items-center gap-2.5">
        <Icon name="InfoCircleOutlined" />
        <span>
          Collection management (Create, Update, Delete) is temporarily unavailable due to ongoing
          system improvements.
        </span>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon-xs"
        aria-label="Dismiss"
        className="text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground dark:hover:bg-primary-foreground/10"
        onClick={() => dispatch(setNotificationBanner(false))}
      >
        <HugeiconsIcon icon={Cancel01Icon} strokeWidth={2} />
      </Button>
    </div>
  );
}

export default NotificationBanner;
